import { useEffect, useState } from "react"
import { encryptUsername } from "./GlobalContext"
import { useGlobalContext } from "./GlobalContext"
const dataURL = process.env.REACT_APP_DATA_JSON_URL

const Register = ({ onOpenLogin }) => {
  const [message, setMessage] = useState({ type: "", text: "" })
  const [loading, setLoading] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const { ag } = useGlobalContext()

  const [formData, setFormData] = useState({
    cmd: "register",
    ag: ag ? ag : "ANOBA",
    findus1: "referral",
    domain: "fgh.fun",
    name: "",
    year: "",
    month: "",
    day: "",
    bank: "",
    banknum: "",
    phone: "",
    email: "",
    password: "",
    confirmPassword: "",
    pin: "",
    from: "",
    agree21: false,
    agreeTnC: false,
    referrerDomain: "",
  })

  const [passwordVisible, setPasswordVisible] = useState(false)
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")

  const today = new Date()
  const ageLimit = new Date(
    today.getFullYear() - 21,
    today.getMonth(),
    today.getDate()
  )

  const maxYear = ageLimit.getFullYear()
  const years = Array.from({ length: 100 }, (_, i) => maxYear - i)

  const selectedYear = parseInt(formData.year)
  const selectedMonth = parseInt(formData.month)

  const months = Array.from({ length: 12 }, (_, i) => i + 1).filter((m) => {
    if (!selectedYear) return true
    if (selectedYear < ageLimit.getFullYear()) return true
    return m <= ageLimit.getMonth() + 1
  })

  const getDaysInMonth = (year, month) => new Date(year, month, 0).getDate()

  const maxDays = getDaysInMonth(selectedYear || 2000, selectedMonth || 1)

  const days = Array.from({ length: maxDays }, (_, i) => i + 1).filter((d) => {
    if (
      selectedYear === ageLimit.getFullYear() &&
      selectedMonth === ageLimit.getMonth() + 1
    ) {
      return d <= ageLimit.getDate()
    }
    return true
  })

  const banks = [
    "Asia United Bank",
    "Bank of Florida",
    "BDO",
    "Bank of Commerce",
    "Bank of the Philippine Islands",
    "BPI Family Bank Savings",
    "BPI Direct BANKO",
    "Bangko Mabuhay",
    "Cebuana Lhuillier Rural Bank Inc.",
    "China Bank",
    "China Bank Savings",
    "Chinatrust Bank",
    "CIMB",
    "DCPAY Philippines",
    "DBP",
    "Dungganon Bank",
    "East West Bank",
    "Equicom Savings Bank",
    "GCASH",
    "GoTyme Bank",
    "Grabpay",
    "ING Bank N.V.",
    "Isla Bank Inc.",
    "Landbank of the Philippines",
    "Malayan Savings Bank",
    "MayBank Phils",
    "Metropolitan Bank and Trust Company",
    "Omnipay, Inc.",
    "PAYMAYA",
    "Partner Rural Bank (Cotabato), Inc.",
    "Philippine Bank of Communications",
    "Philippine Business Bank, Inc.",
    "Philippine National Bank",
    "Philippine National Bank Savings",
    "Philippine Savings Bank",
    "Philippine Trust Company",
    "Philippine Veterans Bank",
    "Quezon Capital Rural Bank",
    "RCBC",
    "Robinsons Bank",
    "SeaBank",
    "Security Bank",
    "Sterling Bank",
    "Sun Savings Bank",
    "UCPB Savings Bank",
    "Union Bank of the Philippines",
    "United Coconut Planters Bank",
    "Wealth Development Bank",
  ]

  const referralSources = [
    "Facebook",
    "Streamers",
    "SMS/Call Invitation",
    "Word of Mouth (Friends/Families)",
    "Google Search",
    "Google Ads",
  ]

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target

    // Allow alphanumeric, limit to 8 characters
    if (name === "password" || name === "confirmPassword") {
      let limited = value.slice(0, 8) // Limit to 8 characters
      setFormData((prevData) => ({
        ...prevData,
        [name]: limited,
      }))
      return
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }))
  }

  const validateForm = () => {
    const nameRegex = /^[a-zA-Z\s]+$/
    const name = formData.name.trim()

    if (!name || !nameRegex.test(name)) {
      setErrorMessage("Invalid Name: Only letters and spaces are allowed.")
      return false
    }

    if (!formData.phone || /[a-z]/i.test(formData.phone)) {
      setErrorMessage("Invalid Mobile Number: Should contain only numbers.")
      return false
    }
    if (!formData.email.includes("@") || !formData.email.includes(".")) {
      setErrorMessage("Invalid Email Address.")
      return false
    }
    if (formData.pin.length !== 4 || /\D/.test(formData.pin)) {
      setErrorMessage("Invalid Pin: Must be exactly 4 digits.")
      return false
    }
    if (!formData.year || !formData.month || !formData.day) {
      setErrorMessage("Please enter your Date of Birth.")
      return false
    }

    const birthDate = new Date(
      parseInt(formData.year),
      parseInt(formData.month) - 1,
      parseInt(formData.day)
    )
    const today = new Date()
    const ageDiff = today.getFullYear() - birthDate.getFullYear()
    const m = today.getMonth() - birthDate.getMonth()
    const d = today.getDate() - birthDate.getDate()
    const isUnder21 =
      ageDiff < 21 || (ageDiff === 21 && (m < 0 || (m === 0 && d < 0)))

    if (isUnder21) {
      setErrorMessage("You must be at least 21 years old to register.")
      return false
    }
    if (formData.password.length < 6 || formData.password.length > 8) {
      setErrorMessage("Password must be between 6 and 8 characters.")
      return false
    }

    if (formData.password !== formData.confirmPassword) {
      setErrorMessage("Passwords do not match!")
      return false
    }
    if (!formData.agree21 || !formData.agreeTnC) {
      setErrorMessage("You must agree to the terms and confirm you are 21+.")
      return false
    }
    setErrorMessage("")
    return true
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setMessage({ type: "", text: "" })
    setLoading(true)

    const isValid = validateForm()
    if (!isValid) {
      setLoading(false)
      return
    }
    try {
      const response = await fetch(dataURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(formData),
      })
      const data = await response.json()

      if (data.emsg) {
        setErrorMessage(data.emsg)
        setTimeout(() => {
          setErrorMessage("")
        }, 6000)
      } else if (data.s) {
        localStorage.setItem("username", encryptUsername(data.u))
        localStorage.setItem("isLoggedIn", "true")
        setMessage({ type: "success", text: "Registration successful" })
        setIsLoggedIn(true)
        window.location.reload()
      }
    } catch (error) {
      setMessage({ type: "error", text: "Error occurred during registration" })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (typeof window === "undefined" || typeof document === "undefined") return

    const params = new URLSearchParams(window.location.search)

    // Try to get `from` from URL query
    let fromParam = params.get("from")

    // Fallback to document.referrer if no `from` in query
    if (!fromParam && document.referrer) {
      try {
        const refUrl = new URL(document.referrer)
        const refDomain = refUrl.hostname.replace(/^www\./, "")

        const currentDomain = window.location.hostname.replace(/^www\./, "")
        if (refDomain && refDomain !== currentDomain) {
          fromParam = refDomain
        }
      } catch (error) {
        console.error("Error parsing referrer:", error)
      }
    }

    // Final fallback default value
    if (!fromParam) {
      fromParam = "fgh.fun"
    }

    setFormData((prevData) => ({
      ...prevData,
      from: fromParam,
      referrerDomain: fromParam,
    }))
  }, [])

  useEffect(() => {
    if (!errorMessage) return

    const timer = setTimeout(() => {
      setErrorMessage("")
    }, 6000)

    return () => clearTimeout(timer)
  }, [errorMessage])

  return (
    <div className="fgh-reg-container">
      <div className="fgh-register-module">
        <form
          id="registerForm"
          className="fgh-form-register"
          onSubmit={handleSubmit}
        >
          <h2 className="fgh-login-reg">Create New Account</h2>
          <p className="already-signed-up fgh-login-reg">
            Already have an account?{" "}
            <a
              href="#"
              style={{ borderBottom: "none" }}
              onClick={(e) => {
                e.preventDefault()
                onOpenLogin()
              }}
            >
              Login
            </a>
          </p>
          {/* Full Name */}
          <input
            type="text"
            name="name"
            className={`form-control ${
              errorMessage.includes("Username") ? "input-error" : ""
            }`}
            placeholder="Name"
            value={formData.name}
            onChange={handleChange}
          />

          {/* Date of Birth */}
          <div className="form-group">
            <label
              style={{
                fontSize: "14px",
                fontWeight: "normal",
                textTransform: "none",
                textAlign: "left",
              }}
              className="fgh-login-reg"
            >
              Date of Birth
            </label>
            <div className="dob-select">
              <select name="year" value={formData.year} onChange={handleChange}>
                <option value="">Year</option>
                {years.map((y) => (
                  <option key={y} value={y}>
                    {y}
                  </option>
                ))}
              </select>
              <select
                name="month"
                value={formData.month}
                onChange={handleChange}
              >
                <option value="">Month</option>
                {months.map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
              </select>
              <select name="day" value={formData.day} onChange={handleChange}>
                <option value="">Day</option>
                {days.map((d) => (
                  <option key={d} value={d}>
                    {d}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Bank Selection */}
          <select
            name="bank"
            className="form-control"
            value={formData.bank}
            onChange={handleChange}
          >
            <option value="">Select Bank</option>
            {banks.map((b) => (
              <option key={b} value={b}>
                {b}
              </option>
            ))}
          </select>

          {/* Account Number */}
          <input
            type="text"
            name="banknum"
            className="form-control"
            placeholder="Bank Account or E-wallet Number"
            value={formData.banknum}
            onChange={handleChange}
          />

          {/* Mobile Number */}
          <input
            type="number"
            name="phone"
            className="form-control"
            placeholder="Mobile Number"
            value={formData.phone}
            onChange={handleChange}
            inputMode="numeric"
          />

          {/* Email */}
          <input
            type="email"
            name="email"
            className="form-control"
            placeholder="E-mail Address"
            value={formData.email}
            onChange={handleChange}
          />

          {/* Password Fields with Toggle */}
          <div className="password-field">
            <input
              type={passwordVisible ? "text" : "password"}
              name="password"
              className={`form-control ${
                errorMessage.includes("Password") ? "input-error" : ""
              }`}
              placeholder="Password must 6 - 8 characters "
              value={formData.password}
              onChange={handleChange}
            />
            <span onClick={() => setPasswordVisible(!passwordVisible)}>
              {passwordVisible ? (
                <img
                  src="/images/icon/hide-password.webp"
                  alt="Hide Password"
                  className="password-icon-status"
                />
              ) : (
                <img
                  src="/images/icon/reveal-password.webp"
                  alt="Show Password"
                  className="password-icon-status"
                />
              )}
            </span>
          </div>

          <div className="password-field">
            <input
              type={confirmPasswordVisible ? "text" : "password"}
              name="confirmPassword"
              className={`form-control ${
                errorMessage.includes("Password") ? "input-error" : ""
              }`}
              placeholder="Confirm Password"
              value={formData.confirmPassword}
              onChange={handleChange}
            />
            <span
              onClick={() => setConfirmPasswordVisible(!confirmPasswordVisible)}
              className="password-icon"
            >
              {confirmPasswordVisible ? (
                <img
                  src="/images/icon/hide-password.webp"
                  alt="Hide Password"
                  className="password-icon-status"
                />
              ) : (
                <img
                  src="/images/icon/reveal-password.webp"
                  alt="Show Password"
                  className="password-icon-status"
                />
              )}
            </span>
          </div>

          {/* Withdrawal Pin */}
          <input
            type="number"
            name="pin"
            min="0"
            max="9999"
            inputMode="numeric"
            className="form-control"
            placeholder="Share Credits PIN"
            value={formData.pin}
            onChange={(e) => {
              let value = e.target.value.replace(/\D/g, "")
              if (value.length > 4) value = value.slice(0, 4)
              setFormData({ ...formData, pin: value })
            }}
          />

          {/* Referral Source */}
          {/* <label
            style={{
              fontSize: "14px",
              fontWeight: "normal",
              textTransform: "none",
              textAlign: "left",
              paddingBottom: "10px",
            }}
          >
            How do you know about us?
          </label>
          <select
            name="from"
            className="form-control"
            value={formData.from}
            onChange={handleChange}
          >
            <option value="">Select</option>
            {referralSources.map((source) => (
              <option key={source} value={source}>
                {source}
              </option>
            ))}
          </select> */}

          {/* Checkboxes */}
          <div className="confirm-checkbox">
            <input
              type="checkbox"
              className="label-confirm"
              name="agree21"
              checked={formData.agree21}
              onChange={handleChange}
            />
            <label
              style={{
                margin: "0",
                fontSize: "14px",
                fontWeight: "normal",
                textTransform: "none",
              }}
              className="fgh-login-reg"
            >
              I confirm that I am at least 21 years old
            </label>
          </div>
          <div className="confirm-checkbox">
            <input
              type="checkbox"
              name="agreeTnC"
              className="label-confirm"
              checked={formData.agreeTnC}
              onChange={handleChange}
            />
            <label
              style={{
                margin: "0",
                fontSize: "14px",
                fontWeight: "normal",
                textTransform: "none",
              }}
              className="fgh-login-reg"
            >
              I agree to the{" "}
              <a
                style={{ borderBottom: "none" }}
                href="/terms-and-conditions/"
                rel="noopener noreferrer"
              >
                Terms and Conditions
              </a>
            </label>
          </div>

          {/* Error Message */}
          <div className="error-container">
            {errorMessage && <p className="error-message">{errorMessage}</p>}
          </div>

          {/* {message.text && (
            <div className={`fgh-message ${message.type}`}>{message.text}</div>
          )} */}

          {/* Submit Button */}
          <button
            type="submit"
            className={`fgh-form-register-btn fgh-normal-button ${
              formData.name.trim() === "" ||
              formData.banknum.trim() === "" ||
              !formData.agree21 ||
              !formData.agreeTnC
                ? "disabled"
                : ""
            }`}
            disabled={
              formData.name.trim() === "" ||
              formData.banknum.trim() === "" ||
              !formData.agree21 ||
              !formData.agreeTnC
            }
          >
            {loading ? "Processing ..." : "Register"}
          </button>
        </form>
      </div>
    </div>
  )
}

export default Register
